module.exports = __webpack_public_path__ + "img/home_pic_3.5_1.7db666ec.webp";